import React from "react";
import {  useSelector , useDispatch} from 'react-redux'; 

import { modifyChampsLeadmemo } from '../../state/redux';

import './DatePrelevement.scss';
const classNames = require('classnames');
function DatePrelevement() {
       const dispatch = useDispatch()
       const leadmemo  = useSelector(state=>state.lead.leadmemo);

    const definedateprelevement= (e)=>{    dispatch(modifyChampsLeadmemo({'date_prelevement':e.target.id }))}

    return ( <div className="wd500"> 
                            <div className='dateprelevement_label' >
                                 Date de prélèvement
                            </div>
                           <div className='dateprelevement_list' >
                                <div id="1"  onClick={definedateprelevement}  className={classNames("clickchoice",{'isvalid':leadmemo.date_prelevement==="1"},{'notvalid':leadmemo.date_prelevement!=="1"})}> 1er du mois</div>
                                <div id="5"  onClick={definedateprelevement}  className={classNames("clickchoice",{'isvalid':leadmemo.date_prelevement==="5"},{'notvalid':leadmemo.date_prelevement!=="5"})}>5 du mois</div>
                                <div id="10"  onClick={definedateprelevement}  className={classNames("clickchoice",{'isvalid':leadmemo.date_prelevement==="10"},{'notvalid':leadmemo.date_prelevement!=="10"})}>10 du mois</div>
                                <div id="15"  onClick={definedateprelevement}  className={classNames("clickchoice",{'isvalid':leadmemo.date_prelevement==="15"},{'notvalid':leadmemo.date_prelevement!=="15"})}>15 du mois</div> 
                            </div>      
                </div>)
}


export default DatePrelevement